import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { PVAPage } from '../../components';
import { CharacteristicDataService } from '../../services';
import { CharacteristicForm } from './CharacteristicForm';
import { Characteristic } from '../../models';
import { NavLink } from 'react-router-dom';

interface CharacteristicCreateState {
    characteristic: Characteristic;
}

export class CharacteristicCreate extends React.Component<BaseRouteProps<{ id: number }>, CharacteristicCreateState> {
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            characteristic: new Characteristic()
        };
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        Create Characteristic
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id + '/characteristics'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    <CharacteristicForm defaultValues={this.state.characteristic} surveyVersionId={this.props.match.params.id} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.characteristicDataService.create(values).then((success) => {
            this.props.history.push('/surveyversion/' + this.props.match.params.id + '/characteristics');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristic/CharacteristicCreate.tsx